import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { apiOrganization } from "../../../../../../../../../../services/Api/Organization/apiOrganization";
import { OtherVenueSettingsApi } from "../../../../../../../../../../services/Api/Organization/types";
import OthersForm from "./components/OthersForm";

const OrganizationSettingsAdvancedOthersPage = () => {
	const { t } = useTranslation();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const [settings, setSettings] = useState<OtherVenueSettingsApi>();
	const { addFlash } = useFlash();

	useEffect(() => {
		fetchSettings();
		handleChangeTabTitle(`${t("lib:common.word.advanced")} | ${t("modules.setting.field.others.title")}`);
	}, []);

	const fetchSettings = async () => {
		try {
			const res = await apiOrganization.getOtherVenueSettings();
			setSettings(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!settings) return <LoadingContainer />;

	return <OthersForm settings={settings} />;
};

export default OrganizationSettingsAdvancedOthersPage;
